var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8002 8.52014C11.8002 11.4201 9.45017 13.7701 6.55017 13.7701C3.66017 13.7701 1.30017 11.4201 1.30017 8.52014C1.30017 5.92014 3.20018 3.7701 5.68018 3.3501V5.02014L7.87018 2.83008L5.68018 0.640137V2.46008C2.72018 2.89008 0.430176 5.44014 0.430176 8.52014C0.430176 11.9001 3.18018 14.6501 6.56018 14.6501C9.94018 14.6501 12.6901 11.9001 12.6901 8.52014H11.8002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.eb31f2b826239ce2a749b7f8a27d89b9.svg";
export { ForwardRef as ReactComponent };